import { render, staticRenderFns } from "./exchangeRateInfo.vue?vue&type=template&id=77e42096&scoped=true"
import script from "./exchangeRateInfo.vue?vue&type=script&lang=js"
export * from "./exchangeRateInfo.vue?vue&type=script&lang=js"
import style0 from "./exchangeRateInfo.vue?vue&type=style&index=0&id=77e42096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e42096",
  null
  
)

export default component.exports